module.exports = __webpack_public_path__ + "static/media/Michael Glueck.4e374f51.png";